import { LoadingButton } from '@mui/lab';
import Paper from '@mui/material/Paper';
import { styled } from '@mui/material/styles';
import { Box, Stack } from '@mui/system';
import { useEffect, useState } from 'react';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';

import { useTheme } from '@mui/material/styles';
import { enqueueSnackbar } from 'notistack';
import FaqsHero from 'src/sections/faqs/faqs-hero';

const StyledPaper = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(3),
  boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.1)',
}));

export default function DashboardTacView() {
  const theme = useTheme();
  const [text, setText] = useState('');

  // const [updateSetting, { isLoading: isUpdating }] = useUpdateSettingMutation();
  // const { data, isLoading } = useGetPrivacyPolicyQuery();
  let settingId = data?._id;

  const handleChange = (value) => {
    setText(value);
  };

  const handleSave = async () => {
    if (!text) {
      return enqueueSnackbar('Please enter content.', { variant: 'error' });
    }
    try {
      const payload = {
        terms_and_conditions: text,
      };
      // const response = await updateSetting({ _id: settingId, data: payload }).unwrap();
      // if (!response.error) {
      //   enqueueSnackbar(response?.message || 'Updated successfully', { variant: 'success' });
      // }
    } catch (error) {
      console.error("Unexpected Error:", error);
    }
  };

  useEffect(() => {
    if (data) {
      setText(data?.terms_and_conditions || '');
    }
  }, [data]);

  return (
    <>
      <FaqsHero data={'Terms & Conditions'} />

      <Stack mt={3}>
        <StyledPaper
          elevation={3}
          sx={{
            ".ql-toolbar": {
              backgroundColor: theme?.palette.mode === 'dark' ? "#fff" : ""
            }
          }}
        >
          <ReactQuill
            value={text}
            onChange={handleChange}
            modules={{
              toolbar: [
                [{ header: '1' }, { header: '2' }, { font: [] }],
                [{ size: [] }],
                ['bold', 'italic', 'underline', 'strike', 'blockquote'],
                [
                  { list: 'ordered' },
                  { list: 'bullet' },
                  { indent: '-1' },
                  { indent: '+1' },
                ],
                ['link', 'image', 'video'],
                ['clean'],
              ],
            }}
            formats={[
              'header',
              'font',
              'size',
              'bold',
              'italic',
              'underline',
              'strike',
              'blockquote',
              'list',
              'bullet',
              'indent',
              'link',
              'image',
              'video',
            ]}
          />
        </StyledPaper>

        <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 3 }}>
          <LoadingButton
            onClick={handleSave}
            type="submit"
            color="primary"
            variant="contained"
          >
            Save
          </LoadingButton>
        </Box>
      </Stack>
    </>
  );
}

const data = {
  terms_and_conditions: `
    <h1>Terms & Conditions</h1>
    <p>Welcome to <strong>Drive Hub</strong>. By accessing or using our platform, you agree to comply with the following terms and conditions.</p>

    <h2>1. Account Registration</h2>
    <ul>
      <li>Users must provide accurate and up-to-date information during registration.</li>
      <li>Accounts are intended for personal or business use only.</li>
    </ul>

    <h2>2. Booking and Payments</h2>
    <ul>
      <li>All bookings and transactions must comply with applicable rules and regulations.</li>
      <li>Payments are processed securely; Drive Hub charges applicable fees where stated.</li>
    </ul>

    <h2>3. Cancellation and Refund Policy</h2>
    <ul>
      <li>Users must adhere to the platform's cancellation rules.</li>
      <li>Refunds are provided according to the platform's policies.</li>
    </ul>

    <h2>4. User Conduct</h2>
    <ul>
      <li>Users must not misuse the platform or engage in unlawful activities.</li>
      <li>Account termination may occur if terms are violated.</li>
    </ul>

    <h2>5. Liability</h2>
    <p>Drive Hub is not responsible for disputes, damages, or losses arising from user interactions or third-party services.</p>

    <h2>6. Modifications</h2>
    <p>Drive Hub reserves the right to update these terms. Changes will be posted with a revised "Last Updated" date.</p>

    <p><strong>Last Updated:</strong> October 16, 2025</p>
  `
};
